import axiosInstance from "./instance";

const toVendorFormData = (vendor) => {
    if (vendor instanceof FormData) {
        return vendor;
    }

    const formData = new FormData();

    Object.entries(vendor || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }

        if (key === 'shopImage' && value instanceof File) {
            formData.append(key, value, value.name);
            return;
        }

        if (Array.isArray(value) || (typeof value === 'object' && !(value instanceof Blob))) {
            formData.append(key, JSON.stringify(value));
            return;
        }

        formData.append(key, value);
    });

    return formData;
};

// Create Vendor
const addVendor = async (vendor) => {
    const response = await axiosInstance.post('/vendors', toVendorFormData(vendor), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

// Get All Vendors by Status
const fetchVendors = async (page, status, limit = 15) => {
    const response = await axiosInstance.get('/vendors', {
        params: {
            page,
            limit,
            status
        }
    });
    return response.data;
}

// Get Rider Earning 
const getEarning = async (vendorId, startDate, endDate) => {
    const response = await axiosInstance.get(`/vendors/${vendorId}/earnings`, {
        params: {
            startDate,
            endDate
        }
    });
    return response.data;
}


// Get Solo Order Details
const fetchVendor = async (vendorId) => {
    const response = await axiosInstance.get(`/vendors/${vendorId}`);
    return response.data;
}

const updateVendor = async (vendorId, status) => {
    const response = await axiosInstance.patch(`/vendors/${vendorId}/status`, {
        status
    });
    return response.data;
}

const updateVendorDetails = async (vendorId, vendor) => {
    const response = await axiosInstance.patch(`/vendors/${vendorId}/details`, toVendorFormData(vendor), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

const deleteVendor = async (vendorId) => {
    const response = await axiosInstance.delete(`/vendors/${vendorId}`);
    return response.data;
}

const updatefeature = async (vendorId, status) => {
    const response = await axiosInstance.patch(`/vendors/${vendorId}/featured`, {
        isFeatured: status === true || status === 'true'
    });
    return response.data;
}

const fetchDashboardVendors = async () => {
    const response = await axiosInstance.get('/dashboard/vendors');
    return response.data;
}

const fetchDashboardUsers = async () => {
    const response = await axiosInstance.get('/dashboard/users');
    return response.data;
}

export { addVendor, fetchVendors, fetchVendor, updateVendor, updateVendorDetails, deleteVendor, updatefeature, fetchDashboardVendors, fetchDashboardUsers, getEarning };
